import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { formatUrl } from '../core'
import ForwardArrowIcon from '../assets/icons/arrow_forward_24.svg'

const Breadcrumb = ({ category, currentPage }) => {
  return (
    <div className="text-sm text-body-light mb-3 flex items-center leading-none hidden lg:block">
      <Link to={`/`} className="text-secondary inline-block hover:underline">
        Home
      </Link>
      {category && (
        <>
          <ForwardArrowIcon className="h-2 w-2 fill-current inline-block mx-2" />
          <Link
            to={`/${formatUrl(category)}/`}
            state={{
              selectedCategory: category,
            }}
            className="text-secondary inline-block hover:underline"
          >
            {category}
          </Link>
        </>
      )}
      {currentPage && (
        <>
          <ForwardArrowIcon className="inline-block h-2 w-2 fill-current mx-2" />
          <span>{currentPage}</span>
        </>
      )}
    </div>
  )
}

Breadcrumb.propTypes = {
  category: PropTypes.string,
  currentPage: PropTypes.string,
}

export default Breadcrumb
